import { cn } from '@/lib/utils'

/** The ASO console's mark: a short bar, a tall bar and a dot above and to
 *  the right of it, stepping up like a rank that climbed. (A dot straight
 *  over the tall bar read as a lowercase "i".) One colour: the square takes the text
 *  colour and the bars and dot are cut out of it in the page colour, so it is
 *  dark on the light theme and light on the dark one. `public/favicon.svg` is
 *  the same drawing. */
export function BrandMark({ size = 22, className }: { size?: number; className?: string }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" aria-hidden className={cn('shrink-0', className)}>
      <rect width="24" height="24" rx="6.5" className="fill-foreground" />
      <rect x="5.4" y="12.6" width="4.2" height="5.8" rx="1.2" className="fill-background" />
      <rect x="11.2" y="8.6" width="4.2" height="9.8" rx="1.2" className="fill-background" />
      <circle cx="18.3" cy="5.7" r="1.9" className="fill-background" />
    </svg>
  )
}

/** Mark and name together: the sidebar head and the sign-in page. */
export function Wordmark({ size = 22, className }: { size?: number; className?: string }) {
  return (
    <span className={cn('inline-flex min-w-0 items-center gap-2', className)}>
      <BrandMark size={size} />
      <span className="flex min-w-0 items-baseline gap-1.5">
        <span className="text-[15px] font-bold leading-none">ASO</span>
        <span className="truncate text-meta leading-none text-muted-foreground">콘솔</span>
      </span>
    </span>
  )
}
